import { motion } from "motion/react";

import FlashDealCard from "@/theme2/components/flashDeals/FlashDealCard";

export default function FlashDealsGrid({ products }) {
  return (
    <motion.section
      initial="hidden"
      animate="visible"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.06,
          },
        },
      }}
      className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6"
      aria-label="Flash deals products"
    >
      {products.map((product) => (
        <motion.div
          key={product.slug}
          variants={{
            hidden: {
              opacity: 0,
              y: 20,
            },
            visible: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={{ duration: 0.45 }}
        >
          <FlashDealCard product={product} />
        </motion.div>
      ))}
    </motion.section>
  );
}